import { render, staticRenderFns } from "./report-incident.vue?vue&type=template&id=49c7a082&"
import script from "./report-incident.vue?vue&type=script&lang=js&"
export * from "./report-incident.vue?vue&type=script&lang=js&"
import style0 from "./report-incident.vue?vue&type=style&index=0&id=49c7a082&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports